/* GS-F7: JS proprio da Glowshine (auditoria F7, achado N1). Ate a V2 ficava no fim de assets/scrolling.js
   (linhas 423-436 do TRABALHO, git 8c090df). Logo do hero (.logo-block) encolhe e o logo do cabecalho aparece
   (body.hero-scrolled) depois de 80 px de rolagem; o CSS esta em assets/glow-base.css.
   Carregado como modulo por snippets/scripts.liquid (executa depois do parse, como antes). */
(function() {
  const logoBlock = document.querySelector('.logo-block');
  if (!logoBlock) return;

  window.addEventListener('scroll', function() {
    if (window.scrollY > 80) {
      logoBlock.classList.add('logo-block--scrolled');
      document.body.classList.add('hero-scrolled');
    } else {
      logoBlock.classList.remove('logo-block--scrolled');
      document.body.classList.remove('hero-scrolled');
    }
  });
})();
